/* Mirelle — interacciones propias (prefijo mr-) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- aparición al hacer scroll (un solo observer) ---------- */
  var observer = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mr-reveal:not(.mr-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mr-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mr-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- barra de avisos que rota ---------- */
  function initAnuncio(root) {
    (root || document).querySelectorAll("[data-mr-anuncio]").forEach(function (bar) {
      if (bar.dataset.mrReady) return; bar.dataset.mrReady = "1";
      var msgs = bar.querySelectorAll(".mr-anuncio__msg");
      if (msgs.length < 2) return;
      var i = 0, timer = null, ms = (parseInt(bar.dataset.segundos, 10) || 5) * 1000;
      function ir(n) {
        i = (n + msgs.length) % msgs.length;
        msgs.forEach(function (m, k) { m.classList.toggle("is-activo", k === i); m.setAttribute("aria-hidden", k === i ? "false" : "true"); });
      }
      function auto() { clearInterval(timer); if (!reduce) timer = setInterval(function () { ir(i + 1); }, ms); }
      var prev = bar.querySelector(".mr-anuncio__flecha--prev"), next = bar.querySelector(".mr-anuncio__flecha--next");
      if (prev) prev.addEventListener("click", function () { ir(i - 1); auto(); });
      if (next) next.addEventListener("click", function () { ir(i + 1); auto(); });
      bar.addEventListener("mouseenter", function () { clearInterval(timer); });
      bar.addEventListener("mouseleave", auto);
      bar.addEventListener("focusin", function () { clearInterval(timer); });
      ir(0); auto();
    });
  }

  /* ---------- carrusel de categorías ---------- */
  function initCarrusel(root) {
    (root || document).querySelectorAll("[data-mr-carrusel]").forEach(function (car) {
      if (car.dataset.mrReady) return; car.dataset.mrReady = "1";
      var slides = car.querySelectorAll(".mr-carrusel__slide");
      if (slides.length < 2) return;
      var i = 0, timer = null, ms = (parseInt(car.dataset.segundos, 10) || 0) * 1000;
      function ir(n) { i = (n + slides.length) % slides.length; slides.forEach(function (sl, k) { sl.classList.toggle("is-activo", k === i); }); }
      function auto() { clearInterval(timer); if (ms && !reduce) timer = setInterval(function () { ir(i + 1); }, ms); }
      var p = car.querySelector("[data-mr-prev]"), n = car.querySelector("[data-mr-next]");
      if (p) p.addEventListener("click", function () { ir(i - 1); auto(); });
      if (n) n.addEventListener("click", function () { ir(i + 1); auto(); });
      var x0 = null;
      car.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      car.addEventListener("touchend", function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { ir(i + (dx < 0 ? 1 : -1)); auto(); } x0 = null; });
      car.addEventListener("mouseenter", function () { clearInterval(timer); });
      car.addEventListener("mouseleave", auto);
      car.mrIr = ir;
      auto();
    });
  }

  /* ---------- pestañas de colecciones ---------- */
  function initPestanas(root) {
    (root || document).querySelectorAll("[data-mr-pestanas]").forEach(function (sec) {
      if (sec.dataset.mrReady) return; sec.dataset.mrReady = "1";
      var tabs = sec.querySelectorAll("[data-mr-pestana]");
      tabs.forEach(function (t) {
        t.addEventListener("click", function () {
          tabs.forEach(function (o) {
            var on = o === t;
            o.classList.toggle("is-activa", on); o.setAttribute("aria-selected", on ? "true" : "false");
            var p = document.getElementById(o.getAttribute("aria-controls")); if (p) p.hidden = !on;
          });
          var panel = document.getElementById(t.getAttribute("aria-controls"));
          if (panel) panel.querySelectorAll(".mr-reveal").forEach(function (el) { el.classList.add("mr-visible"); });
        });
      });
    });
  }

  /* ---------- escaparate: los colores cambian la foto ---------- */
  function initEscaparate(root) {
    (root || document).querySelectorAll("[data-mr-escaparate]").forEach(function (sec) {
      if (sec.dataset.mrReady) return; sec.dataset.mrReady = "1";
      var fotos = sec.querySelectorAll("[data-mr-esc-color]");
      var nombre = sec.querySelector("[data-mr-esc-nombre]");
      var enlaces = sec.querySelectorAll("[data-mr-esc-enlace]");
      var circulos = sec.querySelectorAll(".mr-escaparate__circulo");
      function elegir(b) {
        circulos.forEach(function (c) { var on = c === b; c.classList.toggle("is-activo", on); c.setAttribute("aria-checked", on ? "true" : "false"); });
        fotos.forEach(function (f) {
          var on = f.dataset.mrEscColor === b.dataset.color;
          if (on && f.loading === "lazy") f.loading = "eager";
          f.classList.toggle("is-activa", on);
        });
        if (nombre) nombre.textContent = b.dataset.nombre;
        enlaces.forEach(function (a) { a.href = b.dataset.url; });
      }
      circulos.forEach(function (b) {
        b.addEventListener("click", function () { elegir(b); });
        b.addEventListener("mouseenter", function () { if (window.matchMedia("(hover: hover)").matches) elegir(b); });
      });
      /* precargar las demás fotos cuando la página ya está cargada */
      window.addEventListener("load", function () { setTimeout(function () { fotos.forEach(function (f) { f.loading = "eager"; }); }, 1500); });
      if (circulos.length) elegir(circulos[0]);
    });
  }

  /* ---------- opiniones: abrir/cerrar el formulario ---------- */
  function initOpiniones(root) {
    (root || document).querySelectorAll("[data-mr-opiniones]").forEach(function (sec) {
      if (sec.dataset.mrReady) return; sec.dataset.mrReady = "1";
      var caja = sec.querySelector("[data-mr-opinion-caja]");
      var abrir = sec.querySelector("[data-mr-opinion-abrir]");
      if (abrir && caja) abrir.addEventListener("click", function () {
        caja.hidden = false; abrir.setAttribute("aria-expanded", "true");
        caja.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
        var f = caja.querySelector('input[type="text"]'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 400);
      });
      var cerrar = sec.querySelector("[data-mr-opinion-cerrar]");
      if (cerrar && caja) cerrar.addEventListener("click", function () { caja.hidden = true; if (abrir) { abrir.setAttribute("aria-expanded", "false"); abrir.focus(); } });
      if (/contact_posted=true/.test(location.search) || sec.querySelector(".mr-opiniones__ok, .mr-opiniones__error")) {
        sec.scrollIntoView({ block: "start" });
      }
    });
  }

  /* ---------- guía de tallas (ventana) ---------- */
  function initGuia(root) {
    (root || document).querySelectorAll("[data-mr-guia-abrir]").forEach(function (btn) {
      if (btn.dataset.mrReady) return; btn.dataset.mrReady = "1";
      btn.addEventListener("click", function () {
        var d = document.getElementById(btn.dataset.mrGuiaAbrir);
        if (!d) return;
        var compra = btn.closest("[data-mr-compra]") || document.querySelector("[data-mr-compra]");
        var talla = null;
        if (compra) compra.querySelectorAll("fieldset[data-mr-grupo]").forEach(function (fs) {
          var leg = (fs.querySelector("legend") || {}).textContent || "";
          if (/talla|size|medida/i.test(leg)) { var r = fs.querySelector("input:checked"); if (r) talla = r.value; }
        });
        d.querySelectorAll("tr[data-mr-talla]").forEach(function (tr) {
          var t = tr.getAttribute("data-mr-talla").split(/[\s(]/)[0].toLowerCase();
          tr.classList.toggle("is-tuya", !!talla && t === talla.toLowerCase());
        });
        if (typeof d.showModal === "function") d.showModal(); else d.setAttribute("open", "");
      });
    });
    (root || document).querySelectorAll("dialog.mr-guia").forEach(function (d) {
      if (d.dataset.mrReady) return; d.dataset.mrReady = "1";
      d.querySelectorAll("[data-mr-guia-cerrar]").forEach(function (b) { b.addEventListener("click", function () { d.close ? d.close() : d.removeAttribute("open"); }); });
      d.addEventListener("click", function (e) { if (e.target === d && d.close) d.close(); });
    });
  }

  /* ---------- cifras que cuentan ---------- */
  function initCifras(root) {
    var nums = (root || document).querySelectorAll('[data-mr-count]:not([data-mr-ready])');
    if (!nums.length) return;
    function contar(el) {
      var fin = parseFloat(el.dataset.mrCount); var dec = (el.dataset.mrCount.split('.')[1] || '').length;
      if (reduce || isNaN(fin)) { el.textContent = el.dataset.mrCount; return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t; var p = Math.min((t - t0) / dur, 1); var e = 1 - Math.pow(1 - p, 3);
        el.textContent = (fin * e).toFixed(dec).replace('.', ',');
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { contar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { n.dataset.mrReady = '1'; io.observe(n); });
  }

  /* ---------- galería de producto ---------- */
  function initGaleria(root) {
    (root || document).querySelectorAll('[data-mr-galeria]').forEach(function (g) {
      if (g.dataset.mrReady) return; g.dataset.mrReady = '1';
      var imgs = Array.prototype.slice.call(g.querySelectorAll('.mr-galeria__principal img'));
      var minis = Array.prototype.slice.call(g.querySelectorAll('.mr-galeria__mini'));
      var filtro = null;
      function visibles() { return imgs.map(function (im, k) { return k; }).filter(function (k) { return !filtro || !imgs[k].dataset.mrColor || imgs[k].dataset.mrColor === filtro; }); }
      var actual = Math.max(0, imgs.findIndex(function (im) { return im.classList.contains('is-activa'); }));
      function mostrar(k) {
        actual = k;
        imgs.forEach(function (im, i) { im.classList.toggle('is-activa', i === k); });
        minis.forEach(function (m, i) { m.classList.toggle('is-activa', i === k); m.setAttribute('aria-current', i === k); });
      }
      function paso(d) { var v = visibles(); if (!v.length) return; var p = v.indexOf(actual); mostrar(v[(p + d + v.length) % v.length]); }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { mostrar(i); }); });
      var prev = g.querySelector('.mr-galeria__flecha--prev'); var next = g.querySelector('.mr-galeria__flecha--next');
      if (prev) prev.addEventListener('click', function () { paso(-1); });
      if (next) next.addEventListener('click', function () { paso(1); });
      var x0 = null; var principal = g.querySelector('.mr-galeria__principal');
      if (principal) {
        principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        principal.addEventListener('touchend', function (e) {
          if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) paso(dx < 0 ? 1 : -1); x0 = null;
        });
      }
      g.mrFiltrar = function (color) {
        if (!g.hasAttribute('data-mr-por-color')) return;
        var c = (color || '').toLowerCase();
        if (!imgs.some(function (im) { return im.dataset.mrColor === c; })) return;
        filtro = c;
        minis.forEach(function (m) { if (m.dataset.mrColor) m.hidden = m.dataset.mrColor !== c; });
        if (imgs[actual] && imgs[actual].dataset.mrColor !== c) { var v = visibles(); if (v.length) mostrar(v[0]); }
      };
      g.mrIrA = function (mediaId) {
        imgs.forEach(function (im, k) { if (im.dataset.mediaId === String(mediaId)) mostrar(k); });
      };
      if (g.hasAttribute('data-mr-por-color') && imgs[actual] && imgs[actual].dataset.mrColor) { filtro = imgs[actual].dataset.mrColor; }
    });
  }

  /* ---------- compra: cantidad, variantes, barra fija ---------- */
  function formatoDinero(cents, formato) {
    var v = (cents / 100).toFixed(2);
    var partes = v.split('.');
    var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var coma = entero + ',' + partes[1];
    var punto = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + partes[1];
    return (formato || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, entero)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, partes[0])
      .replace(/\{\{\s*amount\s*\}\}/, punto);
  }

  function initCompra(root) {
    (root || document).querySelectorAll('[data-mr-compra]').forEach(function (c) {
      if (c.dataset.mrReady) return; c.dataset.mrReady = '1';
      var q = c.querySelector('.mr-cantidad input');
      c.querySelectorAll('.mr-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.paso, 10)); q.value = v;
        });
      });
      /* ofertas / packs: cambian la cantidad que se añade al carrito */
      var ofertas = c.querySelectorAll('[data-mr-oferta]');
      if (ofertas.length) {
        var qOferta = c.querySelector('[data-mr-cantidad-oferta]');
        var barraPrecio = document.querySelector('[data-mr-barra-precio]');
        var aplicarOferta = function () {
          var sel = c.querySelector('[data-mr-oferta]:checked') || ofertas[0];
          if (!sel.checked) sel.checked = true;
          if (qOferta) qOferta.value = sel.value;
          if (barraPrecio) barraPrecio.textContent = sel.dataset.total;
        };
        ofertas.forEach(function (o) { o.addEventListener('change', aplicarOferta); });
        aplicarOferta();
      }
      var bandaCta = c.querySelector('[data-mr-banda-cta]');
      if (bandaCta) bandaCta.addEventListener('click', function () {
        var q = bandaCta.dataset.cantidad;
        var radio = c.querySelector('[data-mr-oferta][value="' + q + '"]');
        if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        else { var qi = c.querySelector('[data-mr-cantidad-oferta], .mr-cantidad input'); if (qi) qi.value = q; }
        var b = c.querySelector('.mr-compra__boton'); if (b) b.click();
      });
      var datos = c.querySelector('script[data-mr-variantes]');
      if (datos) {
        var variantes = JSON.parse(datos.textContent);
        var formato = c.dataset.formato;
        var idInput = c.querySelector('form[action*="/cart/add"] input[name="id"]');
        var boton = c.querySelector('.mr-compra__boton');
        var txt = boton ? boton.querySelector('span') : null;
        var precio = c.querySelector('[data-mr-precio]'); var tachado = c.querySelector('[data-mr-tachado]');
        var textoComprar = boton ? boton.dataset.comprar : ''; var textoAgotado = boton ? boton.dataset.agotado : '';
        var grupos = c.querySelectorAll('fieldset[data-mr-grupo]');
        function elegidos() {
          return Array.prototype.map.call(grupos, function (fs) { var r = fs.querySelector('input:checked'); return r ? r.value : null; });
        }
        /* tacha las tallas/colores que no hay con el resto de opciones elegidas */
        function marcarAgotados() {
          var sel = elegidos();
          grupos.forEach(function (fs, gi) {
            fs.querySelectorAll('input[data-mr-opcion]').forEach(function (inp) {
              var hay = variantes.some(function (x) {
                return x.available && x.options.every(function (o, i) { return i === gi ? o === inp.value : (sel[i] === null || o === sel[i]); });
              });
              var lab = inp.nextElementSibling;
              if (lab) { lab.classList.toggle('is-agotado', !hay); if (!hay) lab.setAttribute('title', (inp.value) + ' · ' + textoAgotado); else lab.setAttribute('title', inp.value); }
            });
            var nombre = fs.querySelector('[data-mr-elegido]');
            if (nombre) nombre.textContent = sel[gi] || '';
          });
        }
        marcarAgotados();
        c.addEventListener('change', function (e) {
          if (!e.target.matches('[data-mr-opcion]')) return;
          marcarAgotados();
          var sel = elegidos();
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) { if (boton) { boton.setAttribute('disabled', 'disabled'); if (txt) txt.textContent = c.dataset.noDisponible || 'No disponible'; } return; }
          if (idInput) idInput.value = v.id;
          if (precio) precio.textContent = formatoDinero(v.price, formato);
          if (tachado) { if (v.compare_at_price > v.price) { tachado.textContent = formatoDinero(v.compare_at_price, formato); tachado.hidden = false; } else { tachado.hidden = true; } }
          var ahorroEl = c.querySelector('[data-mr-ahorro]');
          if (ahorroEl) { if (v.compare_at_price > v.price) { ahorroEl.textContent = ahorroEl.dataset.texto + ' ' + formatoDinero(v.compare_at_price - v.price, formato) + (ahorroEl.dataset.pct === 'true' ? ' (-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%)' : ''); ahorroEl.hidden = false; } else { ahorroEl.hidden = true; } }
          if (boton) {
            if (v.available) { boton.removeAttribute('disabled'); if (txt) txt.textContent = textoComprar; }
            else { boton.setAttribute('disabled', 'disabled'); if (txt) txt.textContent = textoAgotado; }
          }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
          var g = document.querySelector('[data-mr-galeria]');
          if (g && g.mrFiltrar) { var gc = c.querySelector('fieldset[data-mr-grupo] .mr-compra__valores--color input:checked'); if (gc) g.mrFiltrar(gc.value); }
          if (v.featured_media && g && g.mrIrA) g.mrIrA(v.featured_media.id);
        });
      }
      var barra = document.querySelector('[data-mr-barra]');
      var ancla = c.querySelector('.mr-compra__fila');
      if (barra && ancla && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(ancla);
        var bb = barra.querySelector('button');
        /* la barra fija siempre añade 1 unidad, sin cambiar el pack elegido arriba */
        if (bb) bb.addEventListener('click', function () {
          var b = c.querySelector('.mr-compra__boton'); if (!b) return;
          var q = c.querySelector('[data-mr-cantidad-oferta], .mr-cantidad input');
          var antes = q ? q.value : null;
          if (q) q.value = 1;
          b.click();
          if (q) setTimeout(function () { q.value = antes; }, 0);
        });
      }
    });
  }

  /* ---------- cuenta atrás hasta la fecha real de fin de oferta ---------- */
  function initCuenta(root) {
    (root || document).querySelectorAll('[data-mr-cuenta]').forEach(function (el) {
      if (el.dataset.mrReady) return; el.dataset.mrReady = '1';
      var m = (el.dataset.fin || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
      if (!m) return;
      var fin = new Date(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, 59).getTime();
      var hms = el.querySelector('[data-hms]');
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), mi = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var r = fin - Date.now();
        if (r <= 0) { el.hidden = true; clearInterval(t); return; }
        el.hidden = false;
        var seg = Math.floor(r / 1000);
        if (hms) { hms.textContent = pad(Math.floor(seg / 3600)) + ':' + pad(Math.floor(seg % 3600 / 60)) + ':' + pad(seg % 60); return; }
        d.textContent = Math.floor(seg / 86400); h.textContent = pad(Math.floor(seg % 86400 / 3600));
        mi.textContent = pad(Math.floor(seg % 3600 / 60)); s.textContent = pad(seg % 60);
        d.style.display = d.nextElementSibling.style.display = seg < 86400 ? 'none' : '';
      }
      var t = setInterval(tick, 1000); tick();
    });
  }

  function initAll(root) {
    initCuenta(root); initReveal(root); initAnuncio(root); initCarrusel(root); initPestanas(root); initEscaparate(root); initOpiniones(root); initGuia(root); initCifras(root); initGaleria(root); initCompra(root); }

  setInterval(function () { initCuenta(); }, 1000);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* editor de Shopify: re-iniciar al añadir/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var bar = e.target.closest('[data-mr-anuncio]');
    if (bar) { bar.querySelectorAll('.mr-anuncio__msg').forEach(function (m) { m.classList.toggle('is-activo', m === e.target); }); }
    var car = e.target.closest('[data-mr-carrusel]');
    if (car && car.mrIr) { var idx = Array.prototype.indexOf.call(car.querySelectorAll('.mr-carrusel__slide'), e.target); if (idx >= 0) car.mrIr(idx); }
  });
})();
